import React from 'react';
import { motion } from 'framer-motion';
import { PullQuote } from './PullQuote';
export interface Stat {
  value: string;
  label: string;
}
interface ResearchSectionProps {
  number: string;
  kicker: string;
  title: string;
  paragraphs: string[];
  stats?: Stat[];
  quote?: {
    text: string;
    attribution?: string;
  };
  image?: {
    src: string;
    caption: string;
  };
  imageSide?: 'left' | 'right';
}
export function ResearchSection({
  number,
  kicker,
  title,
  paragraphs,
  stats,
  quote,
  image,
  imageSide = 'right'
}: ResearchSectionProps) {
  return <section className="w-full bg-paper border-t border-stone-200" data-id="element-116">
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-24" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} data-id="element-118">
          <div className="flex items-baseline gap-4 mb-5" data-id="element-119">
            <span className="font-serif text-2xl text-stone-300 tracking-tightest" style={{
            fontWeight: 500
          }} data-id="element-120">
              {number}
            </span>
            <span className="eyebrow text-trust-600" data-id="element-121">{kicker}</span>
          </div>
          <h2 className="font-serif tracking-tightest text-ink text-3xl md:text-4xl leading-[1.08] max-w-3xl" style={{
          fontWeight: 500
        }} data-id="element-122">
            {title}
          </h2>
        </motion.div>

        <div className={`mt-8 ${image ? 'grid md:grid-cols-2 gap-10 items-start' : ''}`} data-id="element-123">
          <div className={`space-y-5 text-[1.075rem] leading-relaxed text-stone-700 ${image && imageSide === 'left' ? 'md:order-2' : ''}`} data-id="element-124">
            {paragraphs.map((p, i) => <p key={i} data-id="element-125">{p}</p>)}
          </div>

          {image && <figure className={imageSide === 'left' ? 'md:order-1' : ''} data-id="element-126">
              <div className="aspect-[4/3] overflow-hidden rounded-sm" data-id="element-127">
                <img src={image.src} alt="" className="h-full w-full object-cover" data-id="element-128" />
              </div>
              <figcaption className="mt-2 text-xs text-stone-500" data-id="element-129">
                {image.caption}
              </figcaption>
            </figure>}
        </div>

        {stats && <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-px bg-stone-200 border border-stone-200 rounded-sm overflow-hidden" data-id="element-130">
            {stats.map(s => <div key={s.label} className="bg-white p-6" data-id="element-131">
                <p className="font-serif text-3xl tracking-tightest text-trust-700" style={{
            fontWeight: 500
          }} data-id="element-132">
                  {s.value}
                </p>
                <p className="mt-1 text-sm text-stone-600" data-id="element-133">{s.label}</p>
              </div>)}
          </div>}

        {quote && <PullQuote quote={quote.text} attribution={quote.attribution} data-id="element-134" />}
      </div>
    </section>;
}